import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "../../axios";
import { generateParamsFromObj } from "@/common/utils";
import { PaginatedResponseWithTotal, Quote } from "@/common/types";

const getMeCompletedQuotes = async (
  skip: number,
  filters: any,
  searchQ: string
) => {
  const searchFields = ["locationId", "quoteId", "quoteLineId"];
  const take = "10";
  const params = generateParamsFromObj(filters, "filters");
  params.append("take", take);
  params.append("skip", skip.toString());
  params.append("filters[searchQ]", searchQ);
  searchFields.forEach((el) => params.append("searchFields", el));

  return await axiosInstance
    .get("quotes/me", { params })
    .then((res) => res.data)
    .catch((e) => {
      throw e;
    });
};

const useGetMeCompletedQuotes = (
  skip: number,
  filters: Record<
    string,
    string | string[] | number | Record<string, string | string[] | number[]>
  >,
  searchQ: string,
  isEnabled?: boolean
) => {
  return useQuery<PaginatedResponseWithTotal<Quote>>({
    queryKey: [{ type: "completed" }, skip, filters, searchQ],
    queryFn: () => getMeCompletedQuotes(skip, filters, searchQ),
    enabled: isEnabled,
  });
};

export default useGetMeCompletedQuotes;
